import { ChevronDown, ChevronRight, ArrowRight } from 'lucide-react';
import type { MatchReviewRow } from '../../types/matching';
import { useMatchingStore } from '../../store/matchingStore';
import { QueueRowExpanded } from './QueueRowExpanded';

interface QueueRowProps {
  row: MatchReviewRow;
}

export const QueueRow = ({ row }: QueueRowProps) => {
  const expandedRowId = useMatchingStore((s) => s.expandedRowId);
  const expandRow = useMatchingStore((s) => s.expandRow);
  const isExpanded = expandedRowId === row.id;

  const ncesName = row.matchedFields.ncesCandidateData?.name ?? '(no NCES candidate)';
  const blastSummary = [row.organization.city, row.organization.state]
    .filter(Boolean)
    .join(', ');

  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
      <button
        type="button"
        onClick={() => expandRow(isExpanded ? null : row.id)}
        className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
      >
        {isExpanded ? (
          <ChevronDown className="h-4 w-4 text-gray-500 dark:text-gray-400 shrink-0" />
        ) : (
          <ChevronRight className="h-4 w-4 text-gray-500 dark:text-gray-400 shrink-0" />
        )}
        <span className="text-xs font-mono px-2 py-0.5 rounded bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 shrink-0">
          {(row.similarityScore * 100).toFixed(0)}%
        </span>
        <span className="font-medium text-gray-900 dark:text-gray-100 truncate">{ncesName}</span>
        <ArrowRight className="h-4 w-4 text-gray-400 dark:text-gray-500 shrink-0" />
        <span className="text-gray-700 dark:text-gray-300 truncate">{row.organization.name}</span>
        {blastSummary && (
          <span className="text-sm text-gray-500 dark:text-gray-400 shrink-0">{blastSummary}</span>
        )}
      </button>

      {isExpanded && <QueueRowExpanded row={row} />}
    </div>
  );
};
